class CopyEntity {

    constructor() {

        return {
            restrict: 'E',
            templateUrl: 'components/copy-entity.html',
            scope: {
                originalEntity: "=",
                targetEntity: "=?",
                entityName: "=?",
                multiple: "=?"
            },
            controller: ($scope, CONTENT_TYPE, ApiService, EVENTS, $q) => {
                this.$q = $q;
                this.possibleEntities = [CONTENT_TYPE.CLIENT, CONTENT_TYPE.ACCOUNT,CONTENT_TYPE.ADVERTISER, CONTENT_TYPE.CAMPAIGN, CONTENT_TYPE.CREATIVE];
                this.ApiService = ApiService;
                this.$scope = $scope;
                this.$scope.contentType = null; 
                $scope.entities = [];
                $scope.loading = true;
                this.CONTENT_TYPE = CONTENT_TYPE;
                $scope.initialEntities = [];
                $scope.createdEntities = {};

                if(!!!$scope.multiple) { $scope.multiple = false; }

                $scope.$watch('originalEntity', (newVal, oldVal) => {
                    if(!!newVal) {
                        if(newVal.contentType === "x-reflow/feed") {
                            this.possibleEntities = [CONTENT_TYPE.CLIENT, CONTENT_TYPE.ACCOUNT,CONTENT_TYPE.ADVERTISER, CONTENT_TYPE.FEED];
                        }
                        this.initListing(newVal);
                    }
                });

                $scope.$on(EVENTS.COPY_RESET, () => {
                    this.resetView();
                });

                $scope.filterEntities = this.filterEntities.bind(this);
                $scope.updateParentEntities = this.updateParentEntities.bind(this);
            }
        };

    }

    resetView() {
        this.$scope.initialEntities = [];
        this.$scope.entities = [];
        this.$scope.loading = true;
        this.initListing(this.$scope.originalEntity);
    }

    initListing(entity) {
        let contentType = entity.contentType.replace("x-reflow/", "");
        let contentTypeIdx = this.possibleEntities.indexOf(contentType);    
        if(!!!this.$scope.contentTypeIdx) {
            this.$scope.contentTypeIdx = contentTypeIdx;
        }
        let descendant = this.possibleEntities[contentTypeIdx- 1];

        if(contentTypeIdx > 1) {
            this.ApiService.get(descendant, entity[descendant + 'Id'])
                .then((response) => {
                    this.$scope.initialEntities.push({type : descendant, entity : response.data, entities: null});
                    this.initListing(response.data);
                }, (response) => {
                    console.error(response);
                    this.$scope.error = true;
                });
        }
        else {
            this.ApiService.list(descendant, '')
                .then((response) => {
                    let e = response.data.filter(e => e.id == entity[descendant + 'Id'])[0];
                    this.$scope.initialEntities.push({type : descendant, entity : e, entities : null});
                    this.$scope.initialEntities.reverse();
                    this.$scope.targetEntity = this.$scope.initialEntities[this.$scope.initialEntities.length - 1].entity;
                    this.getInitialListing();
                }, (response) => {
                    console.error(response);
                    this.$scope.error = true;
                });
        }

    }

    getInitialListing() {
        let apiCalls = [];
        let idx = this.$scope.initialEntities.length;
        for(let i = 0; i < idx; i++) {
            let queryString = i > 0  ? this.possibleEntities[i -1] + "=" + this.$scope.initialEntities[i-1].entity.id : '';
            apiCalls.push(this.ApiService.list(this.possibleEntities[i], queryString));
        }

        this.$q.all(apiCalls).then(response => {
            let j = 0;
            response.forEach(res => {
                let e = this.$scope.initialEntities[j];
                this.sortEntities(res.data);
                let type = this.$scope.initialEntities[j].type;
                type = type.charAt(0).toUpperCase() + type.slice(1);
                if(j !== 0) { 
                    res.data.unshift({id: -1, contentType: "x-reflow/" + this.$scope.initialEntities[j].type, name : "Create New " + type});
                }
                e.entities = res.data;
                this.$scope.initialEntities[j] = e;
                this.$scope.entities.push(e);
                j++;
            });
            this.$scope.loading = false;
        });

    }
    
    getEntity(contentType, queryString) {
        this.ApiService.list(contentType, queryString)
            .then((response) => {
                this.updateEntities(contentType, response.data);
            }, (response) => {
                console.error(response);
                this.$scope.error = true;
            });
    }

    filterEntities(entity) {
        let contentType = entity.contentType.replace("x-reflow/", "");
        let contentTypeIdx = this.possibleEntities.indexOf(contentType);
        
        if(contentTypeIdx !== this.$scope.contentTypeIdx - 1) {
            if(entity.id > 0) {
                let successor = this.possibleEntities[this.possibleEntities.indexOf(contentType) + 1];
                let queryString = contentType + "=" + entity.id;
                this.getEntity(successor, queryString);
                this.$scope.targetEntity = null;
            }
            else {
                for(let i = contentTypeIdx +1; i < this.$scope.entities.length; i++) {
                    //Don't give the option to create new clients
                    if(i !== 0) {
                        let createObj = {id: -1, contentType: "x-reflow/" + this.$scope.entities[i].type, name : "Create New " + this.$scope.entities[i].type };
                        this.$scope.entities[i].entities = [createObj];
                        this.$scope.entities[i].entity = createObj;
                    }
                }
                this.$scope.targetEntity = null;
            }
        }
        else {
            //Should probably make a deep copy of this, using jquery's extend or similar as because of 2 way binding this affects the original entity passed in
            this.generateTargetEntityParentList();
            this.$scope.targetEntity = entity;
            this.$scope.targetEntity.createdEntities = this.$scope.createdEntities;
        }
    }

    updateEntities(contentType, entities) {
        let idx = this.possibleEntities.indexOf(contentType);

        this.sortEntities(entities);
        this.$scope.entities[idx].entities = entities;
        this.$scope.entities[idx].entity = null;
        let type = this.$scope.entities[idx].type;
        type = type.charAt(0).toUpperCase() + type.slice(1);

        //Don't give the option to create new clients
        if(idx !== 0) {
            this.$scope.entities[idx].entities.unshift({id: -1, contentType: "x-reflow/" + this.$scope.entities[idx].type, name : "Create New " + type });
        }

        for(let i = idx +1; i < this.$scope.entities.length; i++) {
            this.$scope.entities[i].entity = null;
            this.$scope.entities[i].entities = [];
        }

    }

    generateTargetEntityParentList() {
        this.$scope.entities.forEach(entity => {
            if(!!entity.entity) {
                let contentType = entity.entity.contentType.replace("x-reflow/", "");
                if(!!entity.updatedName) {
                    this.$scope.createdEntities[contentType] = {"name" : entity.updatedName};
                }
                else {
                    this.$scope.createdEntities[contentType] =  { "id" : entity.entity.id };
                }
            }
        });
    }

    sortEntities(entities) {
        entities.sort((i1, i2) => {
            let i1Name = i1.name.toLowerCase();
            let i2Name = i2.name.toLowerCase();
            let order = 0;
            if(i1Name > i2Name) { order = 1; }
            else if(i1Name < i2Name) { order = -1; }
            return order;
        });
    }

    updateParentEntities(entity) {
        let contentTypeIdx = this.possibleEntities.indexOf(entity.type);
        this.$scope.createdEntities[entity.type] = entity;
        if(contentTypeIdx > 0 && contentTypeIdx === this.$scope.contentTypeIdx - 1 && (!!entity.updatedName && entity.updatedName.length > 0)) {
            this.$scope.targetEntity  = entity;
            if(!!this.$scope.targetEntity) {
                this.$scope.targetEntity.id = -1;
                this.$scope.originalEntity.entitiesToCreate = this.$scope.createdEntities;
                this.$scope.targetEntity.entitiesToCreate = this.$scope.createdEntities;
            }
        }

        this.generateTargetEntityParentList();
    }
}


angular.module('cpm')
    .directive('copyEntity', [() => {
        'use strict';
        return new CopyEntity();
    }]);
